module.exports = __webpack_public_path__ + "assets/img/G1.25660ce8.png";